import { z } from 'zod'

export const SUBSCRIBER_SESSION_COOKIE = '__Host-mist_subscriber_session'
export const ADMIN_SESSION_COOKIE = '__Host-mist_admin_session'
export const SUBSCRIBER_SESSION_CSRF_HEADER = 'x-mist-csrf'
export const SESSION_MAX_AGE_SECONDS = 30 * 60

export const VerificationConfirmRequestSchema = z.object({
  token: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
})

export const VerificationResendRequestSchema = z.object({
  email: z.string().trim().email().max(320),
  idempotencyKey: z.string().trim().min(1).max(160),
})

export const VerificationResendResponseSchema = z.object({
  status: z.literal('accepted'),
})

export const VerificationConfirmResponseSchema = z.object({
  verified: z.literal(true),
  subscriberPublicId: z.string().min(1),
  csrfToken: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
})

export type VerificationConfirmRequest = z.infer<typeof VerificationConfirmRequestSchema>
export type VerificationConfirmResponse = z.infer<typeof VerificationConfirmResponseSchema>
export type VerificationResendRequest = z.infer<typeof VerificationResendRequestSchema>
export type VerificationResendResponse = z.infer<typeof VerificationResendResponseSchema>
